import React from "react";
import { getStates } from "../../services/helpers";

export interface ConvictedOfCrime {
  ccState: string;
  ccCounty: string;
  ccYear: string;
  comments: string;
}

interface ConvictedOfCrimeProps {
  convictedOfCrime: ConvictedOfCrime;
  validationErrors: { [key: string]: string };
  onInputChange: (
    e: React.ChangeEvent<
      HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
    >,
    field: string,
    index: number
  ) => void;
  onDelete: () => void;
  index: number;
}

const ConvictedOfCrimeForm: React.FC<ConvictedOfCrimeProps> = ({
  convictedOfCrime,
  validationErrors,
  onInputChange,
  onDelete,
  index,
}) => {
  const states = getStates();
  return (
    <div className="data-container">
      {convictedOfCrime && (
        <>
          <div className="field-stacked" style={{ flex: "0 0 20%" }}>
            <label className="field-label">State:</label>
            <select
              className={`form-select ${
                validationErrors[`ccState-${index}`] ? "is-invalid" : ""
              }`}
              value={convictedOfCrime.ccState || ""}
              onChange={(e) => onInputChange(e, "ccState", index)}
            >
              <option value="">Select State</option>
              {states.map((state) => (
                <option key={state.abbreviation} value={state.abbreviation}>
                  {state.name} ({state.abbreviation})
                </option>
              ))}
            </select>
            {validationErrors[`ccState-${index}`] && (
              <div className="invalid-feedback">
                {validationErrors[`ccState-${index}`]}
              </div>
            )}
          </div>

          <div className="field-stacked" style={{ flex: "0 0 25%" }}>
            <label className="field-label">County:</label>
            <input
              className={`form-control ${
                validationErrors[`ccCounty-${index}`] ? "is-invalid" : ""
              }`}
              type="text"
              value={convictedOfCrime.ccCounty || ""}
              onChange={(e) => onInputChange(e, "ccCounty", index)}
            />
            {validationErrors[`ccCounty-${index}`] && (
              <div className="invalid-feedback">
                {validationErrors[`ccCounty-${index}`]}
              </div>
            )}
          </div>

          <div className="field-stacked" style={{ flex: "0 0 20%" }}>
            <label className="field-label">Year:</label>
            <input
              className={`form-control ${
                validationErrors[`ccYear-${index}`] ? "is-invalid" : ""
              }`}
              type="text"
              placeholder="YYYY"
              value={convictedOfCrime.ccYear || ""}
              onChange={(e) => onInputChange(e, "ccYear", index)}
            />
            {validationErrors[`ccYear-${index}`] && (
              <div className="invalid-feedback">
                {validationErrors[`ccYear-${index}`]}
              </div>
            )}
          </div>

          <div className="field-stacked" style={{ flex: "0 0 100%" }}>
            <label className="field-label">
              If Yes, please explain the charges:
            </label>
            <textarea
              className={`form-control ${
                validationErrors[`comments-${index}`] ? "is-invalid" : ""
              }`}
              value={convictedOfCrime.comments || ""}
              onChange={(e) => onInputChange(e, "comments", index)}
              maxLength={1000}
            />
            <div
              style={{
                fontSize: "14px",
                marginTop: "4px",
                textAlign: "right",
              }}
            >
              {convictedOfCrime.comments?.length ?? 0}/1000
            </div>
            {validationErrors[`comments-${index}`] && (
              <div className="invalid-feedback">
                {validationErrors[`comments-${index}`]}
              </div>
            )}
          </div>
          <div style={{ flex: "0 0 100%" }}>
            <button className="oxbtn btn-red" onClick={onDelete}>
              Delete
            </button>
          </div>
        </>
      )}
    </div>
  );
};

export default ConvictedOfCrimeForm;
